import { NavLink } from 'react-router-dom';
import { CalendarHeart, IdCard, MessageCircleMore, CircleUserRound } from 'lucide-react';

export default function BottomNav() {
  return (
    <header
      className="gap-lg flex w-full items-center justify-center flex-shrink-0"
      style={{ viewTransitionName: 'bottom-nav' }}
    >
      <nav className="max-auto max-w-(--container-xs) px-lg pt-md flex w-full border-t !border-stone-400 bg-stone-800 pb-safe-nav text-xs leading-none sm:justify-center sm:border-x">
        <NavLink
          to="/reservations"
          className={({ isActive }) =>
            `hover:text-primary/70 gap-sm grid h-full flex-1 place-content-center place-items-center font-bold text-white ${
              isActive ? 'link-exact-active' : ''
            }`
          }
        >
          <figure className="relative">
            <CalendarHeart className="size-[2rem] [.link-exact-active_&]:fill-white" strokeWidth=".11rem" />
            <CalendarHeart className="absolute left-0 top-0 z-10 hidden size-[2rem] [.link-exact-active_&]:block [.link-exact-active_&]:stroke-black [.link-exact-active_&]:[filter:drop-shadow(1px_0_rgba(255,255,255,.3))_drop-shadow(-1px_0_rgba(255,255,255,.3))_drop-shadow(0_1px_rgba(255,255,255,.3))_drop-shadow(0_-1px_rgba(255,255,255,.3))]" strokeWidth=".11rem" />
          </figure>
          <span>予約履歴</span>
        </NavLink>
        <NavLink
          to="/"
          className={({ isActive }) =>
            `hover:text-primary/70 gap-sm grid h-full flex-1 place-content-center place-items-center font-bold text-white ${
              isActive ? 'link-exact-active' : ''
            }`
          }
        >
          <figure className="relative -mt-[.1rem]">
            <IdCard className="size-[2.2rem] [.link-exact-active_&]:fill-white" strokeWidth=".11rem" />
            <IdCard className="absolute left-0 top-0 z-10 hidden size-[2.2rem] [.link-exact-active_&]:block [.link-exact-active_&]:stroke-black [.link-exact-active_&]:[filter:drop-shadow(1px_0_rgba(255,255,255,.3))_drop-shadow(-1px_0_rgba(255,255,255,.3))_drop-shadow(0_1px_rgba(255,255,255,.3))_drop-shadow(0_-1px_rgba(255,255,255,.3))]" strokeWidth=".11rem" />
          </figure>
          <span className="-mt-[.1rem] block">名刺＆顧客</span>
        </NavLink>
        <NavLink
          to="/announcements"
          className={({ isActive }) =>
            `hover:text-primary/70 gap-sm grid h-full flex-1 place-content-center place-items-center font-bold text-white ${
              isActive ? 'link-exact-active' : ''
            }`
          }
        >
          <figure className="relative">
            <MessageCircleMore className="size-[2rem] [.link-exact-active_&]:fill-white" strokeWidth=".11rem" />
            <MessageCircleMore className="absolute left-0 top-0 z-10 hidden size-[2rem] [.link-exact-active_&]:block [.link-exact-active_&]:stroke-black [.link-exact-active_&]:[filter:drop-shadow(1px_0_rgba(255,255,255,.3))_drop-shadow(-1px_0_rgba(255,255,255,.3))_drop-shadow(0_1px_rgba(255,255,255,.3))_drop-shadow(0_-1px_rgba(255,255,255,.3))]" strokeWidth=".11rem" />
          </figure>
          <span>営業履歴</span>
        </NavLink>
        <NavLink
          to="/mypage"
          className={({ isActive }) =>
            `hover:text-primary/70 gap-sm grid h-full flex-1 place-content-center place-items-center font-bold text-white ${
              isActive ? 'link-exact-active' : ''
            }`
          }
        >
          <figure className="relative">
            <CircleUserRound className="size-[2rem] [.link-exact-active_&]:fill-white" strokeWidth=".11rem" />
            <CircleUserRound className="absolute left-0 top-0 z-10 hidden size-[2rem] [.link-exact-active_&]:block [.link-exact-active_&]:stroke-black [.link-exact-active_&]:[filter:drop-shadow(1px_0_rgba(255,255,255,.3))_drop-shadow(-1px_0_rgba(255,255,255,.3))_drop-shadow(0_1px_rgba(255,255,255,.3))_drop-shadow(0_-1px_rgba(255,255,255,.3))]" strokeWidth=".11rem" />
          </figure>
          <span>マイページ</span>
        </NavLink>
      </nav>
    </header>
  );
}
